import script from "./Maya_Restaurant.vue?vue&type=script&setup=true&lang=js"
export * from "./Maya_Restaurant.vue?vue&type=script&setup=true&lang=js"

import "./Maya_Restaurant.vue?vue&type=style&index=0&id=1feee5b5&setup=true&lang=css"
/* custom blocks */
import block0 from "./Maya_Restaurant.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__